import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "512",
  height: "512"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("path", {
        fill: "#EAEAEA",
        d: "M0 0h512v512H0z"
      }),
      _createElementVNode("path", {
        fill: "#282828",
        d: "M256 368c119.35 0 216 64.464 216 144H40c0-79.536 96.65-144 216-144m.5-252c61.58 0 111.5 51.04 111.5 114s-49.92 114-111.5 114S145 292.96 145 230s49.92-114 111.5-114",
        opacity: ".1"
      })
    ], -1)
  ])))
}
export default { render: render }